export default "__VITE_ASSET__Dih4KiKL__"